module.exports = __webpack_public_path__ + "static/proweek-linkedinBox-55e400461a65d81c827ba37a7f0b7221.png";